import { connect } from 'react-redux';
import PrivateRoute from './PrivateRoute';

const mapStateToProps = ({ user }) => ({
  user: user.data,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrivateRoute);
